type FormatMap = { [key: string]: string };

export enum PointsBehaviorValue {
    ATTENTION_INSTAGRAM = 'ATTENTION_INSTAGRAM', // ("关注 Instagram"),
    ATTENTION_TITTOK = 'ATTENTION_TITTOK', // ("关注 TitTok"),
    ATTENTION_X = 'ATTENTION_X', // ("关注 X"),
    ATTENTION_YOUTUBE = 'ATTENTION_YOUTUBE', // ("关注 Youtube"),
    ATTENTION_FACEBOOK = 'ATTENTION_FACEBOOK', // ("关注 Facebook"),
    ATTENTION_LINE = 'ATTENTION_LINE', // ("关注 LINE"),
    ATTENTION_KAKOO = 'ATTENTION_KAKOO', // ("关注 Kakoo"),
    JOIN_FACEBOOK = 'JOIN_FACEBOOK', // ("加入群组-Facebook"),
    JOIN_KAKOO = 'JOIN_KAKOO', // ("加入群组-Kakoo"),
}

export type PointsBehaviorProps = {
    [key in keyof typeof PointsBehaviorValue]: {
        value: string;
        isFinish: boolean;
    };
};

export const dateFormatMap: FormatMap = {
    us: 'MM/DD/YYYY',
    ca: 'MM/DD/YYYY',
    jp: 'YYYY/MM/DD',
};

export const dateTimeFormatMap: FormatMap = {
    us: 'MM/DD/YYYY HH:mm:ss',
    ca: 'MM/DD/YYYY HH:mm:ss',
    jp: 'YYYY/MM/DD HH:mm:ss',
};

// 欧洲通用时间线
const euCredits11TimeLine = {
    CheckIn: {
        start: new Date('2024/11/19 16:00:00 GMT+8').getTime(),
        end: new Date('2024/11/27 16:00:00 GMT+8').getTime(),
    },
    FlashSale: {
        start: new Date('2024/11/21 16:00:00 GMT+8').getTime(),
        end: new Date('2024/11/25 16:00:00 GMT+8').getTime(),
    },
    BestOffers: {
        start: new Date('2024/11/28 07:00:00 GMT+8').getTime(),
        end: new Date('2024/12/03 16:00:00 GMT+8').getTime(),
    },
    HotPicks: {
        start: new Date('2024/11/19 16:00:00 GMT+8').getTime(),
        end: new Date('2024/12/03 16:00:00 GMT+8').getTime(),
    },
};

const ukCredits11TimeLine = {
    CheckIn: {
        start: new Date('2024/11/19 16:00:00 GMT+8').getTime(),
        end: new Date('2024/11/27 16:00:00 GMT+8').getTime(),
    },
    FlashSale: {
        start: new Date('2024/11/21 16:00:00 GMT+8').getTime(),
        end: new Date('2024/11/25 16:00:00 GMT+8').getTime(),
    },
    BestOffers: {
        start: new Date('2024/11/28 08:00:00 GMT+8').getTime(),
        end: new Date('2024/12/03 16:00:00 GMT+8').getTime(),
    },
    HotPicks: {
        start: new Date('2024/11/19 16:00:00 GMT+8').getTime(),
        end: new Date('2024/12/03 16:00:00 GMT+8').getTime(),
    },
};
const debug = {
    CheckIn: {
        start: new Date('2024/11/07 16:00:00 GMT+8').getTime(),
        end: new Date('2024/11/27 16:00:00 GMT+8').getTime(),
    },
    FlashSale: {
        start: new Date('2024/11/07 16:00:00 GMT+8').getTime(),
        end: new Date('2024/11/27 16:00:00 GMT+8').getTime(),
    },
    BestOffers: {
        start: new Date('2024/11/07 16:00:00 GMT+8').getTime(),
        end: new Date('2024/11/27 16:00:00 GMT+8').getTime(),
    },
    HotPicks: {
        start: new Date('2024/11/07 16:00:00 GMT+8').getTime(),
        end: new Date('2024/11/27 16:00:00 GMT+8').getTime(),
    },
};

export const EU11TimeLineProd: {
    [locale: string]: {
        CheckIn: {
            start: number;
            end: number;
        };
        FlashSale: {
            start: number;
            end: number;
        };
        BestOffers: {
            start: number;
            end: number;
        };
        HotPicks: {
            start: number;
            end: number;
        };
    };
} = {
    // eu: debug,
    // fr: debug,
    // de: debug,
    // it: debug,
    // es: debug,
    // uk: debug,
    eu: euCredits11TimeLine,
    fr: euCredits11TimeLine,
    de: euCredits11TimeLine,
    it: euCredits11TimeLine,
    es: euCredits11TimeLine,
    uk: ukCredits11TimeLine,
};

export const eu11LocaleList = ['eu', 'uk', 'de', 'fr', 'it', 'es'];
